import { FeatureSessionStoreModuleType } from "UidispatcherApiModule";
const { FeatureSessionStoreModule }: { FeatureSessionStoreModule: FeatureSessionStoreModuleType } =
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export const FeatureSessionStore = FeatureSessionStoreModule.default;
